import type { ReactNode } from 'react'

import { cn } from '@/lib/utils';
import TimelineCard, { type TimelineCardProps } from './timeline-card';
import Header from './card-header';

export type TimelineItem = Omit<TimelineCardProps, 'className'> & {
  id: string;
};

type TimelineProps = {
  items?: TimelineItem[];
  className?: string;
  emptyStateLabel?: string;
  controls?: ReactNode;
};

const Timeline = ({
  items = [],
  className,
  emptyStateLabel = 'Nog geen activiteiten geregistreerd.',
  controls,
}: TimelineProps) => {
  if (items.length === 0) {
    return (
      <div className={cn('text-sm text-slate-500', className)}>
        {emptyStateLabel}
      </div>
    );
  }

  return (
    <section className="flex flex-col gap-4  border-slate-200 border p-6 rounded-xl">
      <div className='flex flex-row items-end justify-between gap-4'>
      <Header
        title="Tijdlijn"
        subtitle='Overzicht van alle activiteiten en wijzigingen met betrekking tot deze kandidaat.'
      />
      {controls ? <div className="flex justify-end">{controls}</div> : null}
      </div>
      <ol className={cn('flex flex-col list-none', className)}>
        {items.map(({ id, ...timelineItem }, index) => (
          <li
            key={id}
            className="grid grid-cols-[auto_1fr] items-start pb-6 last:pb-0"
          >
            <div className="relative flex h-full flex-col items-center pt-3">
              {index !== items.length - 1 ? (
                <span
                  aria-hidden
                  className="mt-2 w-px flex-1 bg-border"
                />
              ) : null}
            </div>
            <TimelineCard {...timelineItem} />
          </li>
        ))}
      </ol>
    </section>
  );
};

export default Timeline;
